<template>
  <div>
    <div class="box-content--header container align-items-center justify-content-center hidden">
      <div class="box-content--header__img">
        <div class="img1 container align-items-center justify-content-center animation-bottom">
          <div class="img2 container align-items-center justify-content-center">
            <img src="@/assets/img/icon-words.svg" width="50" alt="Minds">
          </div>
        </div>
      </div>
      <div class="box-content--header__text flex-grow-1 flex-basis-400">
        <h2 class="animation-top animation-delay-02">PERSONAL <span>TEACHER</span></h2>
        <hr class="header-text-hr animation-top animation-delay-02">
        <p class="animation-bottom animation-delay-04">Aprimore seu inglês! Estude com professores online.</p>
      </div>
    </div>
    <div class="box-content shadow-box box-content-border hidden relative">

      <div class="box--item animation-bottom animation-delay-05">
        <div class="teachers">
          <div class="teachers__header">
            <h3 class="teachers__header__heading">Classrooms</h3>
          </div>
          <div class="teachers__header">
            <span class="teachers__header__heading teachers__header__heading--online">online</span>
          </div>
          <div class="teachers__header">
            <div class="box-input">
              <div class="label">
                <label>Classroom Key</label>
              </div>
              <form class="container wrap" @submit.prevent="getClassroom(classroomKey)">
                <div class="input-space container align-items-center margin-left-10 margin-right-10 margin-bottom-10 flex-grow-1 flex-basis-450">
                  <div class="icons">
                    <i class="fas fa-key"></i>
                  </div>
                  <input type="text" placeholder="Classroom Key" class="input" v-model="classroomKey" required>
                </div>
                <div class="margin-left-10 margin-right-10 margin-bottom-10">
                  <button class="btn btn-rounded btn-blue" type="submit">Join Classroom</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-call modal-call__animation--open" ref="modal" v-if="show">
      <div class="modal-call__talking">
        <div class="container wrap modal-call__talking__box">
          <div class="modal-call__talking__streams">
            <div class="modal-call__talking__streams__mine">
              <video ref="teacher_video" class="modal-call__talking__streams__mine__teacher" poster="@/assets/img/offline.jpg" autoplay/>
            </div>
            <div class="modal-call__talking__streams__others">
              <div class="modal-call__talking__streams__others__box">
                <font-awesome-icon icon="user" class="modal-call__talking__streams__others__box__student modal-call__talking__streams__others__box__student--svg" v-if="((stream && stream.active) ? false : true)"/>
                <video ref="mine_video" class="modal-call__talking__streams__others__box__student" autoplay muted v-else/>
                <span>You</span>
              </div>
              <student-video-chat
                v-for="std in students"
                :key="std._id"
                :student="std"
                :ref="`student_video_${std._id}`"
              />
            </div>
          </div>
          <chat-box
            :chat="chat"
            :person="student._id"
            :sendMessage="sendMessage"
            :padding="true"
            :hasStream="(stream && stream.active) ? true : false"
            :muted="muted"
            :startRecording="startRecording"
            :stopRecording="stopRecording"
            :cancelRecording="clearRecorder"
          />
        </div>
        <div class="modal-call__talking__hand" :class="{ disabled: (handRaised || !muted || !((classroom || {}).teacher_connected)) }" >
          <div class="modal-call__talking__hand__icon" @click="raiseHand()">
            <font-awesome-icon icon="hand-paper"/>
          </div>
        </div>
        <div class="modal-call__talking__hangup">
          <div class="modal-call__talking__hangup__icon" @click="leaveRoom()">
            <font-awesome-icon icon="phone-slash"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import io from 'socket.io-client'
  import ChatBox from '@/components/ChatBox'
  import StudentVideoChat from '@/components/StudentVideoChat'

  const PeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
  const SessionDescription = window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitSessionDescription
  const MediaRecorder = window.MediaRecorder

  export default {
    data () {
      return {
        classroomKey: '',
        classroom: null,
        stream: null,
        socket: null,
        socketKeepAlive: null,
        connectionTimeout: null,
        teacherConnection: null,
        show: false,
        students: [],
        chat: [],
        messageText: '',
        // cloneStream: null,
        recorder: null,
        recordChunks: [],
        handRaised: false,
        muted: true,
        recordTime: 0
      }
    },
    computed: {
      student () {
        return this.$store.getters['student/GET']
      }
    },
    components: {
      [ChatBox.name]: ChatBox,
      [StudentVideoChat.name]: StudentVideoChat
    },
    methods: {
      async getClassroom (classroomKey) {
        try {
          this.classroom = await this.$store.dispatch('classroom/find', classroomKey)

          this.classroomKey = ''

          await this.getStream()
        } catch (error) {
          alert(error.message || 'Failed to join classroom')
        }
      },
      async getStream () {
        try {
          this.show = true

          this.stream = await navigator.mediaDevices.getUserMedia({
            video: {
              width: {
                min: 320,
                ideal: 1280,
                max: 1920
              },
              height: {
                min: 240,
                ideal: 720,
                max: 1080
              },
              frameRate: 30, // Shorthand for ideal.
              facingMode: 'environment'
            },
            audio: {
              mandatory: {
                googEchoCancellation: "false",
                googAutoGainControl: "false",
                googNoiseSuppression: "false",
                googHighpassFilter: "false"
              },
              optional: []
            }
          })

          this.$nextTick(() => {
            this.$refs['mine_video'].srcObject = this.stream
          })
        } catch (error) {
          console.log(error)
          alert('Failed to get camera')
        } finally {
          await this.createConnection()
        }
      },
      createConnection () {
        // this.socket = io(`http://${location.hostname}:8082`, {
        this.socket = io('https://live.mindsidiomas.com.br:2020', {
          path: '/socket/classroom',
          transports: ['websocket'],
          secure: true,
          rejectUnauthorized: false
        })

        this.connectionTimeout = setTimeout(() => {
          alert('Failed to connect to server')
          this.leaveRoom()
        }, 1000 * 5)

        this.socket.on('connect', () => {
          if (this.connectionTimeout) {
            clearTimeout(this.connectionTimeout)
            this.connectionTimeout = null
          }

          if (this.socketKeepAlive)
            clearInterval(this.socketKeepAlive)

          this.socketKeepAlive = setInterval(() => {
            this.socket.emit('keep_alive')
          }, 5000)

          this.socket.emit('join_classroom', { school: this.student.school_id, classroom_id: this.classroom._id, student_id: this.student._id })

          this.socket.on('joined_classroom', async () => {
            try {
              const myself = await this.$store.dispatch('classroom/join', {
                classroom: this.classroom,
                socket: this.socket.id,
                has_media: (this.stream && this.stream.active) ? true : false,
                name: this.abreviarNome(this.student.name)
              })

              this.teacherConnection = new PeerConnection({ iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]})

              this.teacherConnection.ontrack = async event => {
                this.$refs['teacher_video'].srcObject = event.streams[0]
              }

              if (this.classroom.teacher_connected) {
                this.socket.emit('connect_to_teacher', {
                  teacher: this.classroom.teacher_socket,
                  student_obj: myself
                })
              }
            } catch (error) {
              alert(error.message || 'Failed to Join Room')
            }
          })

          this.socket.on('failed_join', async error => {
            alert(error.message || 'Failed to Join Room')
            this.leaveRoom()
          })

          this.socket.on('send_chat', chat => {
            for (const c of chat) {
              this.chat.push(c)
            }
          })

          this.socket.on('offer_made_by_teacher', async ({ socket, offer }) => {
            try {
              await this.teacherConnection.setRemoteDescription(new SessionDescription(offer))

              const answer = await this.teacherConnection.createAnswer()

              await this.teacherConnection.setLocalDescription(new SessionDescription(answer))

              this.socket.emit('make_answer_by_student', {
                answer: answer,
                to: socket,
                student_id: this.student._id
              })
            } catch (error) {
              alert(error.message || 'Failed to make connection with the Teacher')
              console.warn(error)
            }
          })

          this.socket.on('offer_requested_by_teacher', socket_id => {
            this.makeTeacherOffer(socket_id)
          })

          this.socket.on('answer_made_by_teacher', async ({ answer }) => {
            try {
              await this.teacherConnection.setRemoteDescription(new SessionDescription(answer))
            } catch (error) {
              alert(error.message || 'Failed to make connection with the Teacher')
              console.warn(error)
            }
          })

          this.socket.on('logged_students', students => {
            this.students = students.map(s => {
              s.connection = this.createStudentConnection(s._id)

              return s
            })
          })

          this.socket.on('student_joined_room', student => {
            const index = this.students.findIndex(s => s._id == student._id)

            if (index > -1) {
              const current = this.students[index]

              if (current.connection && current.connection.connectionState != 'closed')
                current.connection.close()

              student.connection = this.createStudentConnection(student._id)

              this.$set(this.students, index, student)

              this.$nextTick(() => {
                this.makeOffer(student)
              })
            } else {
              student.connection = this.createStudentConnection(student._id)

              this.students.push(student)

              this.$nextTick(() => {
                this.makeOffer(student)
              })
            }
          })

          this.socket.on('offer_made_for_student', async ({ socket, offer, student_id }) => {
            try {
              const student = this.students.find(s => s._id == student_id)

              if (student) {
                await student.connection.setRemoteDescription(new SessionDescription(offer))

                const answer = await student.connection.createAnswer()

                await student.connection.setLocalDescription(new SessionDescription(answer))

                this.socket.emit('make_answer_to_student', {
                  answer: answer,
                  to: socket,
                  student_id: this.student._id
                })
              }
            } catch (error) {
              console.log(error);
              alert(`Failed to Connect with Student!`)
            }
          })

          this.socket.on('answer_made_for_student', async ({ student_id, answer }) => {
            try {
              const student = this.students.find(s => s._id == student_id)

              if (student) {
                await student.connection.setRemoteDescription(new SessionDescription(answer))

                if (student.connection.connectionState != 'connected')
                  this.socket.emit('request_offer_to_student', { to: student.socket, student_id: this.student._id })
              }
            } catch (error) {
              alert(error.message || 'Failed to make connection with the Student')
              console.warn(error)
            }
          })

          this.socket.on('offer_requested_for_student', student_id => {
            const student = this.students.find(s => s._id == student_id)

            if (student)
              this.makeOffer(student)
          })

          this.socket.on('message_sent', message => {
            this.chat.push(message)
          })

          this.socket.on('notification_sent', notification => {
            this.chat.push(notification)
          })

          this.socket.on('failed_to_send_message', errorMessage => {
            alert(errorMessage)
          })

          this.socket.on('setting_muted', ({ student_id, muted }) => {
            const index = this.students.findIndex(s => s._id == student_id)

            this.$set(this.students[index], 'muted', muted)
          })

          this.socket.on('low_hand', () => {
            if (this.handRaised)
              this.handRaised = false

            if ((this.stream && this.stream.active) ? true : false) {
              if (this.muted)
                this.muted = false
            }
          })

          this.socket.on('mute', () => {
            if (!this.muted)
              this.muted = true
          })

          this.socket.on('student_left_room', student_id => {
            const index = this.students.findIndex(s => s._id == student_id)

            if (index > -1) {
              const student = this.students[index]

              if (student.connection && student.connection.connectionState != 'closed')
                student.connection.close()

              this.$set(this.students[index], 'active', false)
            }
          })

          this.socket.on('teacher_disconnected', () => {
            this.$set(this.classroom, 'teacher_connected', false)

            this.$refs['teacher_video'].srcObject = null

            this.teacherConnection = new PeerConnection({ iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]})

            this.teacherConnection.ontrack = async event => {
              this.$refs['teacher_video'].srcObject = event.streams[0]
            }
          })

          this.socket.on('teacher_reconnected', teacher_socket => {
            this.$set(this.classroom, 'teacher_socket', teacher_socket)
            this.$set(this.classroom, 'teacher_connected', true)
          })

          this.socket.on('classroom_closed', this.leaveRoom)
        })
      },
      async makeTeacherOffer (teacher) {
        try {
          if ((this.stream && this.stream.active) ? true : false)
            this.stream.getTracks().forEach(track => this.teacherConnection.addTrack(track, this.stream))

          const offer = await this.teacherConnection.createOffer()

          await this.teacherConnection.setLocalDescription(new SessionDescription(offer))

          this.socket.emit('make_offer_by_student', {
            offer: offer,
            to: teacher,
            student_id: this.student._id
          })
        } catch (error) {
          console.log(error);
          alert(`Failed to Connect with Teacher!`)
        }
      },
      createStudentConnection (student_id) {
        const pc = new PeerConnection({ iceServers: [{ urls: 'stun:stun.l.google.com:19302' }] })

        if ((this.stream && this.stream.active) ? true : false)
          this.stream.getTracks().forEach(track => pc.addTrack(track, this.stream))

        pc.ontrack = async event => {
          const video = this.$refs[`student_video_${student_id}`][0]

          if (video)
            video.setStream(event.streams[0])
        }

        return pc
      },
      async makeOffer (student) {
        try {
          const offer = await student.connection.createOffer()

          await student.connection.setLocalDescription(new SessionDescription(offer))

          this.socket.emit('make_offer_to_student', {
            offer: offer,
            to: student.socket,
            student_id: this.student._id
          })
        } catch (error) {
          console.log(error);
          alert(`Failed to Connect with ${student.name}!`)
        }
      },
      leaveRoom () {
        try {
          this.show = false

          if (this.stream) {
            const tracks = this.stream.getTracks()

            for (const track of tracks) {
              track.stop()
            }
          }

          if (this.classroom)
            this.classroom = null

          if (this.socket) {
            this.socket.disconnect(true)
            this.socket = null
          }

          if (this.socketKeepAlive) {
            clearInterval(this.socketKeepAlive)
            this.socketKeepAlive = null
          }

          if (this.teacherConnection) {
            this.teacherConnection.close()
            this.teacherConnection = null
          }

          for (const student of this.students) {
            if (student.connection && student.connection.connectionState != 'closed')
              student.connection.close()
          }

          this.students = []
          this.chat = []
          this.handRaised = false
          this.muted = true
        } catch (error) {
          alert(error.message || 'Failed to close classroom')
        }
      },
      abreviarNome (nome) {
        const nameList = nome.split(' ').filter(n => !['DE', 'DA'].includes(n.toUpperCase()))

        if (nameList.length <= 2)
          return nome

        nome = nameList[0]

        for (let x = 1; x < (nameList.length - 1); x++) {
          nome += ` ${nameList[x][0].toUpperCase()}.`
        }

        nome += ` ${nameList[nameList.length - 1]}`

        return nome
      },
      sendMessage (message) {
        if (message && this.socket && this.socket.connected) {
          this.socket.emit('send_message', {
            classroom: this.classroom._id,
            _id: this.student._id,
            name: this.abreviarNome(this.student.name),
            message: message,
            is_media: false
          })

          return true
        }
        return false
      },
      async sendRecord (blob, time) {
        if (blob && this.socket && this.socket.connected) {
          try {
            const { url, filename } = await this.$store.dispatch('classroom/saveRecord', {
              classroom: this.classroom._id,
              student: this.student._id,
              record: blob
            })

            this.socket.emit('send_message', {
              classroom: this.classroom._id,
              _id: this.student._id,
              name: this.abreviarNome(this.student.name),
              is_media: true,
              media_url: url,
              media_name: filename,
              media_duration: time
            })
          } catch (error) {
            alert('Failed to send Audio')
            console.warn(error)
          }
        }
      },
      onRecordError (error) {
        this.clearRecorder()
        alert((error && error.message) || 'Failed to record audio')
      },
      onRecordDataAvailable (event) {
        this.recordChunks.push(event.data)
      },
      onRecordStop () {
        if (this.recordChunks.length) {
          const blob = new Blob(this.recordChunks, { 'type' : 'video/webm' })

          this.sendRecord(blob, this.recordTime)
        }

        this.clearRecorder()
      },
      startRecording () {
        if (!MediaRecorder)
          return false

        try {
          if (this.stream && this.stream.active) {
            this.clearRecorder()

            this.$refs['mine_video'].captureStream = this.$refs['mine_video'].captureStream || this.$refs['mine_video'].mozCaptureStream

            // this.cloneStream = this.$refs['mine_video'].captureStream()
            //
            // const videoTrack = this.cloneStream.getTracks().find(t => t.kind == 'video')
            //
            // if (videoTrack)
            //   this.cloneStream.removeTrack(videoTrack)
            //
            // this.recorder = new MediaRecorder(this.cloneStream, {
            this.recorder = new MediaRecorder(this.$refs['mine_video'].captureStream())

            this.recorder.addEventListener('error', this.onRecordError)
            this.recorder.addEventListener('dataavailable', this.onRecordDataAvailable)
            this.recorder.addEventListener('stop', this.onRecordStop)

            this.recorder.start()
          }

          return true
        } catch (error) {
          this.clearRecorder()
          alert(error.message || 'Failed to record audio')
          return false
        }
      },
      stopRecording (time) {
        if (this.recorder) {
          if (this.recorder.state != 'inactive') {
            this.recordTime = time
            this.recorder.stop()
          }
        }
      },
      clearRecorder () {
        // if (this.cloneStream) {
        //   this.cloneStream.getTracks().forEach(track => track.stop())
        //   this.cloneStream = null
        // }

        if (this.recorder) {
          if (this.recorder.state != 'inactive') {
            this.recorder.removeEventListener('stop', this.onRecordStop)
            this.recorder.stop()
          }

          this.recorder = null
        }

        if (this.recordChunks.length)
          this.recordChunks = []
      },
      raiseHand () {
        if (this.socket && this.socket.connected) {
          if (!this.handRaised && this.muted && this.classroom && this.classroom.teacher_connected) {
            this.handRaised = true

            this.socket.emit('raise_hand', {
              teacher: this.classroom.teacher_socket,
              from: {
                _id: this.student._id ,
                name: this.abreviarNome(this.student.name)
              }
            })
          }
        }
      }
    },
    // created () {
    //   this.$store.dispatch('student/addListener')
    // },
    // beforeDestroy () {
    //   this.$store.dispatch('student/removeListener')
    // }
  }
</script>

<style media="screen" lang="scss">
@import './src/assets/css/base/variables';

.teachers {
  min-height: 400px;
  display: flex;
  flex-direction: column;
  &__header {
    padding: 0 10px;
    &:not(:first-child) {
      padding: 5px 10px;
      margin-bottom: 10px;
    }
    &__heading {
      text-align: left;
      &--online {
        float: left;
        border: 2px solid #57BE29;
        border-radius: 15px;
        color: #57BE29;
        text-transform: uppercase;
        padding: 1px 35px;
      }
    }
  }
  &__box {
    display: flex;
    flex-direction: column;
    border: 5px solid #ccc !important;
    border-radius: 15px;
    min-height: 223px;
    padding: 5px 0px;
    &__item {
      padding: 5px;
      &__info {
        display: flex;
        border: 2px solid #ccc !important;
        border-radius: 25px;
        padding: 5px;
        &__name {
          padding-left: 15px;
          flex-basis: 85%;
          span {
            line-height: 22px;
          }
        }
        &__call {
          flex-basis: 15%;
          display: flex;
          justify-content: center;
          &__btn {
            width: 80px;
            &:disabled {
              color: #888181;
              background-color: #d6d6d6;
            }
          }
        }
      }
    }
  }
}

.modal-call {
  overflow: hidden;
  display: flex;
  justify-content: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  top: 0;
  left: 0;
  background-color: rgba(25, 25, 25, 0.95);
  color: #fff;
  &.modal-call__animation--open {
    animation: open .8s ease-in;
  }
  &.modal-call__animation--close {
    animation: close .5s ease-out;
  }
  &__talking {
    &__box {
      height: 100%;
      max-height: 100%;
    }
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-self: center;
    overflow: hidden;
    z-index: 100;
    &__classroomkey {
      color: $color-red;
      font-size: 32px;
      margin: 20px auto;
    }
    &__streams {
      min-width: 350px;
      padding: 10px;
      flex: 1;
      display: flex;
      flex-direction: column;
      max-height: 100%;
      &__mine {
        display: flex;
        justify-content: center;
        height: auto;
        flex: 1;
        max-height: 60%;
        &__teacher {
          width: 100%;
          height: auto;
        }
      }
      &__others {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        max-height: 40%;
        overflow-y: auto;
        &__box {
          min-width: 200px;
          max-width: calc((100% / 6) - (6 * 10px));
          padding: 5px;
          cursor: pointer;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: column;
          &__student {
            width: auto;
            height: auto;
            max-width: calc(100% - 10px);
            max-height: calc(100% - 10px);
          }
          &__student--svg {
            width: 63% !important;
            height: auto;
          }
        }
      }
    }
    &__hangup {
      cursor: pointer;
      position: absolute;
      top: 7px;
      right: 20px;
      background-color: #C20030;
      color: #fff;
      padding: 15px 13px;
      border-radius: 150px;
      svg {
        font-size: 30px;
      }
    }
    &__hand {
      cursor: pointer;
      position: absolute;
      top: 7px;
      right: 90px;
      background-color: $color-blue;
      color: #fff;
      padding: 15px 18px;
      border-radius: 150px;
      svg {
        font-size: 30px;
      }

      &.disabled {
        cursor: not-allowed;
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .modal-call__talking {
    &__box {
      padding-top: 77px;
      padding-bottom: 10px;
      height: calc(100% - 35vh);
      max-height: calc(100% - 35vh);
    }
    &__streams__mine {
      height: calc(100% - 175px);
      max-height: calc(100% - 175px);
    }
    &__streams__others {
      height: 175px;
      flex-wrap: nowrap;
    }
  }
}

@keyframes open {
  0% {
    clip-path: circle(0% at 50% 50%);
    opacity: 0;
  }
  100% {
    clip-path: circle(100% at 50% 50%);
    opacity: 1;
  }
}

@keyframes close {
  0% {
    clip-path: circle(100% at 50% 50%);
    opacity: 1;
  }
  100% {
    clip-path: circle(0% at 50% 50%);
    opacity: 0;
  }
}

@keyframes calling {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes callingEntry {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/onlineClass/index.vue